import { SkillTypeDto } from '@/api/generated';

import { componentsTranslations } from './comnponents/components.translations.fr.ts';
import { type AppTranslations, NAMESPACE } from './translations.pl.ts';
import { utilsTranslations } from './util/utils.translations.fr.ts';
import { viewsTranslations } from './views/views.translations.fr.ts';

export const frTranslation: AppTranslations = {
  [NAMESPACE]: {
    components: componentsTranslations,
    // LEGAL: draft French translation of the GDPR consents and the data processing information.
    // It must be approved by the Orange Polska legal team before French goes to production.
    consents: {
      additionalPersonalDataProcessingConsentOrange:
        "Je consens au traitement, par Orange Polska S.A., dont le siège social est situé à Varsovie, des données que j'ai fournies volontairement. J'accepte qu'Orange Polska S.A. (dont le siège social est situé à Varsovie) traite les données personnelles qui ne sont pas exigées par la loi mais que j'ai fournies volontairement dans ma candidature, aux fins du processus de recrutement que j'ai indiqué pour Orange Polska S.A.",
      collapse: 'réduire',
      dataProcessingInfoHtml: `<p>En soumettant ta candidature, tu consens au traitement des données personnelles que tu as fournies dans le cadre de ce processus de recrutement, y compris à l'envoi d'une demande d'avis anonyme et facultatif sur la qualité du recrutement.</p><br/><p>Le responsable du traitement de tes données personnelles est Orange Polska S.A., dont le siège social est situé à Varsovie, Aleje Jerozolimskie 160, 02-326 Warszawa (ci-après Orange Polska). Coordonnées du délégué à la protection des données d'Orange Polska : inspektorochronydanych@orange.com</p><br/><p>Dans le cadre du recrutement, nous traiterons les données exigées par la loi ainsi que d'autres données obtenues lors des entretiens de recrutement, notamment issues des tests auxquels tu as participé et d'autres méthodes de vérification des compétences et aptitudes utilisées lors des entretiens, obtenues avec ton consentement. Ces données serviront à établir tes compétences et aptitudes et à les évaluer au regard des exigences du poste auquel tu postules.</p><br/><p>Tes données seront traitées aux fins de la conduite du processus de recrutement sur la base de la loi (obligation légale du responsable du traitement) et, pour les données dont le traitement ne découle pas de la loi ainsi qu'aux fins de l'envoi d'une demande d'avis anonyme et facultatif sur la qualité du recrutement, sur la base de ton consentement :</p><br/><p>&ndash; pendant 12 mois à compter de la date de dépôt de la candidature,</p><br/><p>&ndash; pendant 24 mois à compter de la date de dépôt de la candidature, si tu as consenti au traitement de tes données dans le cadre de recrutements futurs.</p><br/><p>La communication des données comprenant tes nom et prénom, ta date de naissance, ton adresse de correspondance, ton adresse e-mail ou ton numéro de téléphone, ta formation, tes qualifications professionnelles et ton parcours professionnel découle de la loi. La communication des autres données est facultative.</p><br/><p>Tes données personnelles peuvent être transmises :</p><br/><p>a) aux sous-traitants qui coopèrent avec Orange Polska dans la conduite du recrutement ou qui fournissent une assistance juridique,</p><br/><p>b) aux entités qui exploitent pour notre compte des systèmes informatiques et de télécommunication ou qui nous fournissent des outils informatiques, ainsi qu'à leurs sous-traitants.</p><br/><p>Tu as le droit :</p><br/><p>- de retirer ton consentement à tout moment ; le retrait du consentement n'affecte pas la licéité du traitement fondé sur le consentement effectué avant ce retrait,</p><br/><p>- de demander l'accès à tes données traitées par Orange Polska,</p><br/><p>- de rectifier (corriger) tes données,</p><br/><p>- de demander l'effacement de tes données ou la limitation de leur traitement,</p><br/><p>- à la portabilité des données, c'est-à-dire le droit de recevoir les données traitées par Orange Polska ou de demander leur transfert à une autre entité,</p><br/><p>- de t'opposer au traitement de tes données.</p><br/><p>L'étendue de chacun de ces droits et les situations dans lesquelles ils peuvent être exercés découlent de la loi. Le droit que tu peux exercer dépendra par exemple de la base juridique et de la finalité du traitement des données. Pour exercer ces droits, tu peux envoyer une demande par courrier à : Orange Polska S.A., Al. Jerozolimskie 160, 02-326 Warszawa ou par e-mail à rekrutacja@orange.com. Si</p><br/><p>nécessaire, nous pourrons te demander de fournir des informations complémentaires permettant de t'authentifier afin de vérifier si tu es en droit de présenter la demande.</p><br/><p>Si tu estimes que tes données personnelles sont traitées de manière illicite, tu peux introduire une réclamation auprès du Président de l'Office de protection des données personnelles (UODO).</p><br/><p>Par ailleurs, en soumettant ta candidature, tu confirmes avoir pris connaissance de la Procédure interne commune de signalement des violations du droit et de mise en œuvre des mesures de suivi dans les entités du Groupe Orange Polska, ci-après la &quot;Procédure de signalement interne&rdquo;.</p><br/><p>La Procédure de signalement interne est disponible à l'adresse :</p><br/><p>https://www.orange.pl/etyka-i-compliance</p>
`,
      dataProcessingInfoTitle:
        'Informations sur le traitement des données personnelles chez Orange Polska S.A., dont le siège social est situé à Varsovie',
      expand: 'développer',
      futureRecruitmentDataProcessingConsentOrange:
        "Je consens au traitement, par Orange Polska S.A., dont le siège social est situé à Varsovie, de mes données personnelles contenues dans les documents que j'ai fournis, aux fins de ma participation à de futurs processus de recrutement menés par Orange Polska S.A. ",
      requiredConsent: 'consentement obligatoire',
      warningNoConsent:
        'Si tu ne coches pas le consentement ci-dessus, nous ne pourrons pas te contacter',
    },
    quizFinishedPage: {
      messages: {
        '0': {
          message: "C'est presque tout",
          subMessage:
            'Ta candidature est presque prête. Les domaines métier qui t\'intéressent sont : <span class="text-primary font-bold">{{ areas }}</span>',
        },
        '1': {
          message: "Ce n'est pas encore fini",
          subMessage:
            "Dans un instant, je te demanderai aussi d'évaluer ton niveau de connaissance des compétences clés pour nous dans les domaines que tu as choisis.",
        },
      },
    },
    quizInitializedPage: {
      buttons: {
        next: 'Suivant',
      },
      errorMessage: 'Impossible de charger la question du quiz.',
      heading: "Bienvenue dans l'application Quiz",
      unsupportedType: 'Type de question non pris en charge',
    },
    skillsAssessmentCollectedPage: {
      buttons: {
        finish: 'Terminer !',
      },
      heading: 'Merci pour cette aventure commune',
      subMessage1: "Ta candidature vient d'être envoyée. ",
      subMessage2:
        'Tu recevras notre retour sous 3 jours ouvrés. Tu trouveras la description complète du processus de recrutement ',
      subMessage3: 'La confirmation de réception de ta candidature',
      subMessage4: "t'a été envoyée par e-mail. ",
      subMessage5: "Si le message n'est pas arrivé, contacte-nous : {{ contactEmail }} ",
      subMessage6: 'À bientôt !',
      here: 'ici',
      competence: 'Compétence',
      skillTypes: {
        [SkillTypeDto.ProgrammingLanguage]: 'Langages de programmation',
        [SkillTypeDto.Tool]: 'Outils',
        [SkillTypeDto.SystemTechnologyMethodology]: 'Systèmes, technologies, méthodes de travail',
        [SkillTypeDto.Language]: 'Langues',
      },
      introText:
        'Choisis les compétences que tu considères comme tes points forts. Sur cette base, nous pourrons te proposer le stage le plus adapté à tes capacités et à ton potentiel.',
      languageIntroText: 'Pour finir, évalue ton niveau en langues :',
      standardRatingLabels: {
        noKnowledge: 'Aucune connaissance',
        basic: 'Notions de base',
        good: 'Bon',
        advanced: 'Avancé',
      },
      standardRatingDescriptions: {
        noKnowledge: "Je n'ai aucune connaissance dans ce domaine",
        basic:
          "J'ai des connaissances de base, souvent théoriques, et j'ai besoin d'aide pour les tâches pratiques",
        good: "J'ai les connaissances et je sais les utiliser efficacement dans des tâches courantes, mais j'ai besoin d'aide pour les plus complexes",
        advanced:
          "Je maîtrise la technologie et je l'utilise de façon autonome dans la plupart des situations, même difficiles",
      },
      standardRatingShortLabels: {
        noKnowledge: 'Aucune',
        basic: 'Notions de base',
        good: 'Bon',
        advanced: 'Avancé',
      },
      languageRatingLabels: {
        a1a2: 'A1/A2',
        b1b2: 'B1/B2',
        c1c2: 'C1/C2',
        native: 'Natif',
      },
    },
    startGamePage: {
      buttons: {
        startGame: 'Commencer le jeu',
      },
      heading: 'Ce que tu dois savoir avant de commencer le jeu de recrutement :',
      list: {
        listItem1:
          "tu as {{ timeToCompleteInMinutes }} minutes pour terminer le jeu, ce qui te permet de plonger dans l'univers d'Orange et de résoudre les tâches à ton rythme",
        listItem2: 'les tâches du jeu ont un niveau de difficulté similaire',
        listItem3: 'trouve un endroit calme où rien ne te dérangera',
        listItem4: 'vérifie que tu as une bonne connexion internet',
        listItem5: "le jeu a une bande-son : si tu veux l'écouter, prépare tes écouteurs",
        listItem6: 'après avoir terminé le jeu, tu recevras un retour',
        listItem7: "tu ne peux jouer qu'une seule fois",
        listItem8:
          "si tu interromps le jeu pour des raisons techniques (par ex. pas d'internet), tu peux y revenir, mais une seule fois et à l'endroit où il s'est arrêté",
      },
    },
    utils: utilsTranslations,
    views: viewsTranslations,
    welcomeAgainPage: {
      buttons: {
        continue: 'Continuer',
      },
      heading: 'Ravi de te revoir ici.',
      subMessage:
        "Je commençais à croire que je t'avais perdu de vue. Ne perdons pas de temps. Tu peux reprendre le jeu de recrutement.",
    },
    welcomePage: {
      buttons: {
        submit: "C'est parti !",
      },
      // LEGAL: draft French translation of the email consent, see the note at consents above
      checkboxText:
        "Je consens au traitement de mes données personnelles (l'adresse e-mail fournie) aux fins de recevoir des communications par e-mail dédiées au recrutement pour les stages Let's Orange.",
      description:
        "Acquiers de l'expérience et développe-toi chez Orange en travaillant sur des projets qui comptent. Il est temps de jouer à ta façon et de découvrir tes propres talents.",
      emailPlaceholder: 'Saisis ton adresse e-mail',
      passwordPlaceholder: 'Mot de passe',
      emailPrompt: 'Commence par vérifier ton adresse e-mail.',
      error: {
        wentWrong: "Quelque chose s'est mal passé",
      },
      heading1: "L'avenir",
      heading2: 'est là',
      popup: {
        message: "Nous avons envoyé un lien de vérification à l'adresse e-mail que tu as indiquée",
        subMessage:
          'Clique sur le lien dans le message reçu et passe aux étapes suivantes du recrutement.',
        emailNotReceived1: "L'e-mail n'est pas arrivé ? Vérifie ton dossier spam ou clique ",
        emailNotReceived2: ' pour le renvoyer.',
        emailNotReceivedHere: 'ici',
        resendEmailSent: " C'est fait !",
      },
      subheading1: "Postule sans CV aux stages Let's Orange.",
      subheading2: 'Entre dans le jeu de recrutement et joue à ta façon.',
    },
  },
};
